import { useAppConfigs } from '@config/config.hooks';
import React, { useEffect } from 'react';

export const useDeferLoading = (isLoading: boolean, isFormDirty = false, deferTimeInMs = 3000) => {
  const appConfigs = useAppConfigs();

  const [loading, setLoading] = React.useState(isLoading);
  const deferTimer = React.useRef<ReturnType<typeof setTimeout>>();
  const deferredSetIsLoading = (isLd: boolean) => {
    if (isLd) {
      setLoading(isLd);
      return;
    }
    deferTimer.current = setTimeout(() => {
      setLoading(isLd);
    }, deferTimeInMs);
  };

  useEffect(() => {
    if (!appConfigs.updateConfigs || typeof appConfigs.updateConfigs !== 'function') return;
    appConfigs.updateConfigs((configs) => {
      return {
        ...configs,
        isAnyActionLoading: isFormDirty ? false : isLoading,
      };
    });
  }, [isLoading, isFormDirty]);

  React.useEffect(() => {
    if (isLoading) {
      deferredSetIsLoading(isLoading);
      if (deferTimer.current) clearTimeout(deferTimer.current);
    }
    if (!isLoading) {
      deferredSetIsLoading(isLoading);
    }
  }, [isLoading]);

  React.useEffect(() => {
    if (deferTimer.current) clearTimeout(deferTimer.current);
  }, []);

  return { loading, setLoading: deferredSetIsLoading };
};
